export const aboutData = {
  brandName: '天美影视',
  slogan: '追剧，本该如此简单',
  intro: '天美影视成立于2018年，是国内领先的免费高清电视剧在线观看平台。我们致力于为广大追剧爱好者提供最新、最全、最高清的电视剧资源，让每一位用户都能享受到流畅、无广告干扰的追剧体验。',
  mission: '让每个人都能轻松追到好剧',
  vision: '成为中国最受欢迎的免费影视平台',
  stats: [
    { label: '上线剧集', value: '10,000+' },
    { label: '活跃用户', value: '500万+' },
    { label: '日均播放', value: '3,000万+' },
    { label: '合作制作方', value: '200+' },
  ],
  features: [
    {
      title: '海量资源',
      description: '涵盖国内外热门电视剧，类型丰富，持续更新',
      icon: 'ri-database-2-line',
    },
    {
      title: '高清画质',
      description: '支持1080P高清播放，极致视觉体验',
      icon: 'ri-4k-line',
    },
    {
      title: '流畅播放',
      description: '智能CDN加速，多线路切换，告别卡顿',
      icon: 'ri-speed-up-line',
    },
    {
      title: '完全免费',
      description: '无需注册付费，打开即看，畅享追剧乐趣',
      icon: 'ri-gift-line',
    },
  ],
  testimonials: [
    {
      name: '追剧达人小李',
      role: '忠实用户 · 3年',
      content: '天美影视真的是我每天必刷的平台，更新速度快，画质清晰，而且完全免费！每次新剧上线都能第一时间看到，太赞了！',
      rating: 5,
    },
    {
      name: '影视爱好者小王',
      role: 'VIP用户 · 2年',
      content: '用过很多追剧平台，天美影视是最稳定的一个。播放流畅不卡顿，分类也很清晰，找剧特别方便。强烈推荐！',
      rating: 5,
    },
    {
      name: '剧荒拯救者小张',
      role: '新用户 · 6个月',
      content: '朋友推荐的天美影视，一试就停不下来。剧集分类做得太好了，根据类型找剧特别方便，每天都有新发现！',
      rating: 4,
    },
  ],
  contact: {
    email: 'contact@tianmeitv.com',
    wechat: '天美影视官方',
    weibo: '@天美影视',
    address: '北京市朝阳区望京SOHO T1栋 15层',
    phone: '400-888-6666',
  },
  timeline: [
    { year: '2018', event: '天美影视正式上线，首批上线500部电视剧' },
    { year: '2019', event: '用户突破100万，上线高清播放功能' },
    { year: '2020', event: '推出移动端适配，支持手机平板观看' },
    { year: '2021', event: '用户突破500万，日均播放量超1000万次' },
    { year: '2022', event: '引入智能推荐系统，用户体验全面升级' },
    { year: '2023', event: '资源库突破10000部，成为行业领先平台' },
    { year: '2024', event: '推出4K超清专区，持续引领行业标准' },
  ],
};